import { IHistoryPractice } from '@app/api/academic.api';
import { Table, TableProps } from 'antd';
import { TableCollapseDetail } from './detail';

interface TableCollapseProps<RecordType> {
  columns: TableProps<RecordType>['columns'];
  dataSource: RecordType[];
}

export const TableCollapse: React.FC<TableCollapseProps<IHistoryPractice>> = ({ columns, dataSource, ...rest }) => {
  // const getExpandedRowContent = (record: IResultDetail) => {
  //   const Component = COMPONENT_MAP[record.questionType];
  //   return Component ? <Component data={record} /> : null;
  // };

  return (
    <Table
      expandable={{
        expandedRowRender: (record) => <TableCollapseDetail data={record} />,
        rowExpandable: (record) => record.id !== 'Not Expandable',
        expandRowByClick: false,
        defaultExpandAllRows: false,
      }}
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      rowKey="id"
      {...rest}
    />
  );
};
